import type { CSSInterpolation } from '@emotion/serialize';
import classNames from 'classnames';
import React, { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import type { StaticTextLookupKey } from 'src/translators/static-text-lookup';
import { TranslatedStaticText } from 'src/translators/static-text-translator';

type WebsiteLinkButtonContentProps = {
  buttonText?: string | React.ReactElement | null;
  buttonKey?: StaticTextLookupKey;
  buttonCss?: CSSInterpolation;
  buttonEndIcon?: React.ReactElement;
  buttonType?: string;
  contentClassName?: string;
  gtmTrackingId?: string;
};

export const WebsiteLinkButtonContent: React.FC<WebsiteLinkButtonContentProps> = ({
  buttonText,
  buttonKey,
  buttonCss,
  buttonEndIcon,
  buttonType,
  contentClassName,
  gtmTrackingId,
}) => {
  const { styling, isMeridian } = use(SiteContext);
  const buttonStyle = isMeridian ? styling.redesignButtons.orange : styling.buttons.primary;

  return (
    <div
      css={buttonCss ? buttonCss : buttonStyle}
      className={classNames(buttonType ?? 'button-inline', contentClassName)}
      data-gtmid={gtmTrackingId || (typeof buttonText === 'string' ? buttonText : undefined)}
    >
      {buttonText || (buttonKey && <TranslatedStaticText lookupKey={buttonKey} />)}
      {buttonEndIcon}
    </div>
  );
};
